import Model, { ID, Integer } from 'src/models/model'

export default class SupportCategory extends Model {
  static name = 'SupportCategory'

  static versioned = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String
      },
      displayOrder: {
        type: Integer,
        default: 9999
      }
    }
  }
}
